export default "__VITE_ASSET__mQ$m6k1v__"